import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { KaufpeisPremiumCalculationService } from '@base/app/features/calculator-overview/services/kaufpeis-premium-calculation.service';
import { createKaufpreisCalculatorForm, KaufpreisCalculatorFormModel } from '../../factories/kaufpreis-calculator-form.factory';
import { KaufpreisService } from '../../services/kaufpreis.service';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';

@Component({
  selector: 'app-kaufpreis-calculator',
  standalone: true,
  imports: [
    CurrencyPipe,
    PaginatorModule,
    ReactiveFormsModule
  ],
  templateUrl: './kaufpreis-calculator.component.html',
  styleUrl: './kaufpreis-calculator.component.scss',
  providers: [KaufpeisPremiumCalculationService]
})
export class KaufpreisCalculatorComponent implements OnInit {
  private readonly kaufpreisService = inject(KaufpreisService);

  @Output() requestOffer = new EventEmitter<{ initialPrice: number, premium: number }>();

  form!: FormGroup<KaufpreisCalculatorFormModel>;
  premium: number | null = null;

  ngOnInit() {
    this.form = createKaufpreisCalculatorForm();

    this.form.valueChanges.pipe(
      debounceTime(300),
      filter(value => value.initialPrice !== null && value.initialPrice !== undefined),
      distinctUntilChanged(
        (prev, curr) =>
          prev.initialPrice === curr.initialPrice),
      switchMap(value => this.kaufpreisService.getPremium(value.initialPrice!))
    )
      .subscribe(premium => {
        this.premium = premium;
      });

    this.checkForInitialPriceInUrl();
  }

  private checkForInitialPriceInUrl(): void {
    const url = new URL(window.location.href);

    if (this.form.controls.initialPrice.value === null && url.searchParams.has('listenpreis')) {
      this.form.controls.initialPrice.setValue(Number(url.searchParams.get('listenpreis')));
    }
  }

  submit(): void {
    this.form.markAllAsTouched();

    if (this.form.invalid || this.premium === null) {
      return;
    }

    this.requestOffer.emit({
      initialPrice: this.form.getRawValue().initialPrice!,
      premium: this.premium
    });
  }
}

